// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SELz","clinicsSelect":"styles_clinicsSelect__1F-_k"};